import { QueryClient } from "@tanstack/react-query";

function getStatusFromError(error) {
  return (
    error?.response?.status ??
    error?.status ??
    error?.cause?.response?.status ??
    null
  );
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: false,
      retry: (failureCount, error) => {
        const status = getStatusFromError(error);
        if (status && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});
